import Fuse from "fuse.js";

type IFuseOptions<T> = Fuse.IFuseOptions<T>;

const useFuse = <T>(data: T[], options: IFuseOptions<T>) => {
  const fuse = new Fuse(data, options);
  return fuse;
};

export default useFuse;
